import { render, staticRenderFns } from "./PricingDesktop.vue?vue&type=template&id=0875fe92&"
import script from "./PricingDesktop.vue?vue&type=script&lang=js&"
export * from "./PricingDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PricingDesktop.vue?vue&type=style&index=0&id=0875fe92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports